import { Box } from '@mui/material';

export const EmptyData = () => (
  <Box display="flex" alignItems="center" justifyContent="center" width="100%" height="100%">
    🫥 Empty Data
  </Box>
);
